<div class="list-page">
    <div class="list-page__add-block">
      <button-cmp class="add-button-block" (click)="onAddButtonClick()" isLogin="false" isAdd="true"
        title="Add Blog Post"></button-cmp>
    </div>
    <div class="list-page__table-block">
      <app-blog-posts-table *ngIf="postsList$ | async as list" [table-data]="list.slice().reverse()"
        [page]="page" class="table-block" (action)="receivedAction($event)"></app-blog-posts-table>
      <!-- <table-cmp *ngIf="booksList$ | async as list" [isSlokaType]="true" [table-data]="list.slice().reverse()"
        [page]="page" class="table-block" (action)="receivedAction($event)"></table-cmp> -->
    </div>
    <div class="list-page__pagination-block">
      <pagination-controls class="table-paginate" (pageChange)="page = $event"></pagination-controls>
    </div>
  </div>
  